module.exports = __webpack_public_path__ + "img/gordon-moody.58b2bf89.png";